import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db, hasFirebaseConfig } from '../lib/firebase';

export const saveInquiry = async (inquiry) => {
  if (!hasFirebaseConfig || !db) {
    return { saved: false, reason: 'missing_firebase_config' };
  }

  await addDoc(collection(db, 'contact_inquiries'), {
    ...inquiry,
    status: 'new',
    source: 'website-contact-form',
    createdAt: serverTimestamp(),
  });

  return { saved: true };
};
